import React/*, { Component }*/ from "react";
import { compose } from 'redux';
import PropTypes from "prop-types";
import { GridColumn as Column, GridDetailRow } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import Header from "../components/Header";
import queryString from "query-string";
import Tabs from "../components/Tabs";
import Tab from "../components/Tab";
import ReportsDataFilters from "../components/ReportsDataFilters";
import config from '../config/config'
import isPage from "../hoc/isPage";
import { AppContext } from "../context/AppContext";
import { isEmpty, /*qremoveSpaces*/ getExportFileName, kebabCase, getRoleID } from "../helpers";
import {
    DateCell,
    BooleanCell,
    PercentCell,
    //EditBookingButtonCell,
    BlankCell,
    CurrencyCell
} from "../components/utils/GridHelpers";
import ExcelExportButtonCell from "../components/utils/GridHelpers";
import GridContainer from '../components/GridContainer';
import moment from 'moment';
import localize from "../hoc/localize";
const uuidv4 = require('uuid/v4');


// used for the suggested order history report only
class SuggestedHistoryDetailedComponent extends GridDetailRow {

    orderType = ""; // 0: all; 1: GM; 2: P&A

    // get the data to export in the csv download.
    // only 3 fields: part number, quantity, and package (a bool field)
    // no headers.
    getCsvData = (orders) => {
        let csvData = [];
        const { allowEditSuggestedOrders } = this.context.state;

        orders.forEach(order => {
            // export order quantity if it exists, otherwise just export suggested quantity

            let quantity = order.suggestedQty;
            if (allowEditSuggestedOrders && order.orderQty !== null) {
                quantity = order.orderQty
            }
            if (quantity > 0) {
                csvData.push([
                    order.partNumber,
                    quantity
                ]);
            }

        });
        return csvData;
    }

    getFileName = (data, fileExtension) => {
        // dealer name - vendor code - order date - extension
        const dealerName = data.dealerName;
        const vendorCode = data.vendorCode;

        const orderDate = moment(data.orderDate, "YYYYMMDD").format("YYYY-MM-DD");

        //let fileName = `${removeSpaces(dealerName)}-${vendorCode}`;
        let fileName = `${dealerName.replace(/\s/g, '-')}-${vendorCode}`;
        switch (parseInt(this.orderType, 10)) {
            case 1:
                fileName = `${fileName}-GM`;
                break;
            case 2:
                fileName = `${fileName}-P&A`;
                break;
            default:
                break;
        }

        return `${fileName}-${orderDate}.${fileExtension}`;
    }

    render() {

        const data = this.props.dataItem;

        if (data.parts && data.parts[0].partNumber !== null) {
            if (!isEmpty(this.context.state.selectedOrderType)) {
                this.orderType = this.context.state.selectedOrderType
                    ? this.context.state.selectedOrderType.orderTypeID
                    : null;
            }

            //const excelFileName = this.getFileName(data, 'xlsx');
            //const csvFileName = this.getFileName(data, 'csv');

            // check if there are any subitems
            //excelFilename = { excelFileName }
            //csvFilename={csvFileName}
            //{
            //    this.context.state.allowEditSuggestedOrders ?
            //    <Column
            //        key="neverOrder"
            //        field="neverOrder"
            //        title="Never Order"
            //        headerClassName="boolean"
            //        className="boolean"
            //        width="175px"
            //        cell={(props) => (
            //            <BooleanCell mode="checkbox" {...props} />
            //        )}
            //    /> : <React.Fragment />
            //}
            //{
            //    this.context.state.allowEditSuggestedOrders ? (
            //        <Column
            //            field="adjustmentReason"
            //            title="Adjustment Reason"
            //            width="250px"
            //        />
            //    ) : <React.Fragment />
            //}
            //<div className="detail-grid with-toolbar">
            return (
                <div className="detail-grid">
                    <GridContainer
                        sortColumn=""
                        data={data.parts}
                        csvData={this.getCsvData(data.parts)}
                        referenceID={data.suggestedPOID}
                        toolbarClassName="special"
                    >

                        <Column
                            field="partNumber"
                            title={this.props.returnLocalizedString("m0257")}
                            width="200px"
                        />
                        <Column
                            field="partDescription"
                            title={this.props.returnLocalizedString("m0258")}
                            width="250px"
                        />

                        {/* SuggestedQty */}
                        <Column
                            field="suggestedQty"
                            title={this.props.returnLocalizedString("m0314")}
                            width="150px"
                            className="numeric"
                            headerClassName="numeric"
                        />

                        {/* OrderQty */}
                        {this.context.state.allowEditSuggestedOrders ?
                            <Column
                                key="orderQty"
                                field="orderQty"
                                title={this.props.returnLocalizedString("m0315")}
                                width="150px"
                                className="numeric"
                                headerClassName="numeric"
                            /> : <React.Fragment />}

                        <Column
                            field="package"
                            title={this.props.returnLocalizedString("m0316")}
                            headerClassName="boolean"
                            className="boolean"
                            width="90px"
                            cell={props => (
                                <BooleanCell mode="checkbox" {...props} />
                            )}
                        />
                        <Column
                            field="packageCount"
                            title={this.props.returnLocalizedString("m0317")}
                            width="150px"
                            className="numeric"
                            headerClassName="numeric"
                        />

                        <Column
                            field="cost"
                            title={this.props.returnLocalizedString("m0318")}
                            width="100px"
                            className="numeric"
                            headerClassName="numeric"
                            cell={props => (
                                <CurrencyCell {...props} />
                            )}
                        />
                        <Column
                            field="total"
                            title={this.props.returnLocalizedString("m0267")}
                            width="125px"
                            className="numeric"
                            headerClassName="numeric"
                            cell={props => (
                                <CurrencyCell {...props} />
                            )}
                        />

                        <Column
                            excludeFromExport
                            cell={(props) => (
                                <BlankCell {...props} />
                            )}
                        />
                    </GridContainer>
                </div >
            );
        } else {
            return (
                <div className="detail-grid">
                    {this.props.returnLocalizedString("m0319")}
                </div>
            );
        }
    }
}
SuggestedHistoryDetailedComponent.contextType = AppContext;
const SuggestedHistoryDetailedComponentLocalized = localize(SuggestedHistoryDetailedComponent);
SuggestedHistoryDetailedComponentLocalized.displayName = "SuggestedHistoryDetailedComponent";


function columnsTopSellerItems(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20, editable: false },
        { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
        { field: "partDescription", key: "partDescription", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false },
        { field: "qtyInStock", key: "qtyInStock", title: props.returnLocalizedString("m0321"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "totalValue", key: "totalValue", title: props.returnLocalizedString("m0322"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "qtySold", key: "qtySold", title: props.returnLocalizedString("m0323"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsInventory(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20, editable: false },
        { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
        { field: "partDescription", key: "partDescription", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false },
        { field: "qtyInStock", key: "qtyInStock", title: props.returnLocalizedString("m0321"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "totalValue", key: "totalValue", title: props.returnLocalizedString("m0322"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "lastSoldDate", key: "lastSoldDate", title: props.returnLocalizedString("m0324"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "status", key: "status", title: props.returnLocalizedString("m0290"), minWidnt: 20, editable: false },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsTopPerformers(props) {
    return [
        { field: "dealerNumber", key: "dealerNumber", title: props.returnLocalizedString("m0334"), minWidnt: 20, editable: false },
        { field: "dealerName", key: "dealerName", title: props.returnLocalizedString("m0200"), minWidnt: 20, editable: false },
        { field: "lastMonthRevenue", key: "lastMonthRevenue", title: props.returnLocalizedString("m0325"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "lastMonthProfit", key: "lastMonthProfit", title: props.returnLocalizedString("m0326"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "agedInventory9month", key: "agedInventory9month", title: props.returnLocalizedString("m0327"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "inventoryTurnoverRate", key: "inventoryTurnoverRate", title: props.returnLocalizedString("m0328"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "gmroi", key: "gmroi", title: props.returnLocalizedString("m0329"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsTopOverstocking(props) {
    return [
        { field: "dealerNumber", key: "dealerNumber", title: props.returnLocalizedString("m0334"), minWidnt: 20, editable: false },
        { field: "dealerName", key: "dealerName", title: props.returnLocalizedString("m0200"), minWidnt: 20, editable: false },
        { field: "agedValue", key: "agedValue", title: props.returnLocalizedString("m0330"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsSuggestedOrderHistory(props) {
    return [
        { field: "orderDate", key: "orderDate", title: props.returnLocalizedString("m0331"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0332"), minWidnt: 20, editable: false },
        { field: "totalItems", key: "totalItems", title: props.returnLocalizedString("m0333"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "totalValue", key: "totalValue", title: props.returnLocalizedString("m0322"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { key: "button", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: ExcelExportButtonCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsInventoryMixComparison(props) {
    return [
        //{ field: "orgID", key: "orgID", title: "Org ID", minWidnt: 20, editable: false },
        { field: "dealerNumber", key: "dealerNumber", title: props.returnLocalizedString("m0334"), minWidnt: 20, editable: false },
        { field: "dealerName", key: "dealerName", title: props.returnLocalizedString("m0200"), minWidnt: 20, editable: false },
        { field: "inventoryValue", key: "inventoryValue", title: props.returnLocalizedString("m0335"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "agedPercent", key: "agedPercent", title: props.returnLocalizedString("m0336"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "agedValue", key: "agedValue", title: props.returnLocalizedString("m0330"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "obsoletePercent", key: "obsoletePercent", title: props.returnLocalizedString("m0337"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "obsoleteValue", key: "obsoleteValue", title: props.returnLocalizedString("m0338"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "slowMovingPercent", key: "slowMovingPercent", title: props.returnLocalizedString("m0339"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "slowMovingValue", key: "slowMovingValue", title: props.returnLocalizedString("m0340"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "averageMovingPercent", key: "averageMovingPercent", title: props.returnLocalizedString("m0341"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "averageMovingValue", key: "averageMovingValue", title: props.returnLocalizedString("m0342"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "fastMovingPercent", key: "fastMovingPercent", title: props.returnLocalizedString("m0343"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "fastMovingValue", key: "fastMovingValue", title: props.returnLocalizedString("m0344"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsInventoryMixHistory(props) {
    return [
        { field: "date", key: "date", title: "Date", minWidnt: 20, editable: false, cell: DateCell },
        { field: "inventoryValue", key: "inventoryValue", title: props.returnLocalizedString("m0335"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "agedPercent", key: "agedPercent", title: props.returnLocalizedString("m0336"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "agedValue", key: "agedValue", title: props.returnLocalizedString("m0330"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "obsoletePercent", key: "obsoletePercent", title: props.returnLocalizedString("m0337"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "obsoleteValue", key: "obsoleteValue", title: props.returnLocalizedString("m0338"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "slowMovingPercent", key: "slowMovingPercent", title: props.returnLocalizedString("m0339"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "slowMovingValue", key: "slowMovingValue", title: props.returnLocalizedString("m0340"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "averageMovingPercent", key: "averageMovingPercent", title: props.returnLocalizedString("m0341"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "averageMovingValue", key: "averageMovingValue", title: props.returnLocalizedString("m0342"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "fastMovingPercent", key: "fastMovingPercent", title: props.returnLocalizedString("m0343"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "fastMovingValue", key: "fastMovingValue", title: props.returnLocalizedString("m0344"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsPartSalesHistory(props) {
    return [
        { field: "partNumber", key: "partNumber", title: props.returnLocalizedString("m0257"), minWidnt: 20, editable: false },
        { field: "vendorCode", key: "vendorCode", title: props.returnLocalizedString("m0259"), minWidnt: 20, editable: false },
        { field: "partDescription", key: "partDescription", title: props.returnLocalizedString("m0258"), minWidnt: 20, editable: false },
        { field: "totalSales", key: "totalSales", title: props.returnLocalizedString("m0373"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric", cell: CurrencyCell },
        { field: "totalSalesHit", key: "totalSalesHit", title: props.returnLocalizedString("m0374"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "totalQtySold", key: "totalQtySold", title: props.returnLocalizedString("m0345"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        //{ field: "qtyRefunded", key: "qtyRefunded", title: props.returnLocalizedString("m0346"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "qtySpecialOrdered", key: "qtySpecialOrdered", title: props.returnLocalizedString("m0347"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "maxSoldDate", key: "maxSoldDate", title: props.returnLocalizedString("m0324"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "currentQtyAvailable", key: "currentQtyAvailable", title: props.returnLocalizedString("m0348"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "currentQtyOnOrder", key: "currentQtyOnOrder", title: props.returnLocalizedString("m0349"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "currentQtySalesInProgress", key: "currentQtySalesInProgress", title: props.returnLocalizedString("m0350"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsUsageStats(props) {
    return [
        { field: "date", key: "date", title: props.returnLocalizedString("m0352"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "country", key: "country", title: props.returnLocalizedString("m0104"), minWidnt: 20, editable: false },
        { field: "orgName", key: "orgName", title: props.returnLocalizedString("m0102"), minWidnt: 20, editable: false },
        { field: "userName", key: "userName", title: props.returnLocalizedString("m0353"), minWidnt: 20, editable: false },
        { field: "logins", key: "logins", title: props.returnLocalizedString("m0354"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "orderViews", key: "orderViews", title: props.returnLocalizedString("m0355"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "csvOrderExports", key: "csvOrderExports", title: props.returnLocalizedString("m0356"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "xlsOrderExports", key: "xlsOrderExports", title: props.returnLocalizedString("m0357"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "apiOrderExports", key: "apiOrderExports", title: props.returnLocalizedString("m0358"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "neverOrders", key: "neverOrders", title: props.returnLocalizedString("m0359"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "orderQuantityEdits", key: "orderQuantityEdits", title: props.returnLocalizedString("m0360"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "stockingEdits", key: "stockingEdits", title: props.returnLocalizedString("m0361"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "reportViews", key: "reportViews", title: props.returnLocalizedString("m0362"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};
function columnsAdoption(props) {
    return [
        { field: "orgName", key: "orgName", title: props.returnLocalizedString("m0102"), minWidnt: 20, editable: false },
        { field: "orgID", key: "orgID", title: props.returnLocalizedString("m0363"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "vendorName", key: "vendorName", title: props.returnLocalizedString("m0364"), minWidnt: 20, editable: false },
        { field: "submittedOnFrom", key: "submittedOnFrom", title: props.returnLocalizedString("m0365"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "submittedOnTo", key: "submittedOnTo", title: props.returnLocalizedString("m0366"), minWidnt: 20, editable: false, cell: DateCell },
        { field: "orderedFromSuggestedPartsQtyPct", key: "orderedFromSuggestedPartsQtyPct", title: props.returnLocalizedString("m0367"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "orderedFromSuggestedPartsValuePct", key: "orderedFromSuggestedPartsValuePct", title: props.returnLocalizedString("m0368"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { field: "sOMSuggestedPortionOfPOTotalValuePct", key: "sOMSuggestedPortionOfPOTotalValuePct", title: props.returnLocalizedString("m0369"), minWidnt: 20, editable: false, headerClassName: "numeric", className: "numeric" },
        { key: "blank", minWidnt: 20, editable: false, filterable: false, resizable: false, sortable: false, reorderable: false, cell: BlankCell }
    ]
};

const ADJUST_PADDING = 0;
const COLUMN_MIN = 4;

class ReportsDataPage extends React.Component {
    static propTypes = {

        role: PropTypes.shape({
            roleID: PropTypes.string,
            role: PropTypes.string  // name of role
        }),

        // what mode is the page operating in?
        // options:
        //      reports (normalReports)
        //      admin >> admin reports (adminReports)
        mode: PropTypes.oneOf([
            "normalReports",
            "adminReports",
            "bookingReports"
        ])
    }

    reportTitle = ""; // e.g. "Top Seller Items"
    reportType = ""; // e.g. top-seller-items
    values = null; // orderType - 0: all; 1: GM; 2: P&A

    // the "autoFilter" variables below are parameters passed when drilling down from other parts of the app
    autoFilterType = "";
    autoFilterStartDate; // start and end date to use for the drilldown run of this report
    autoFilterEndDate;
    previousPageUrl = "";
    previousPageTitle = "";

    minGridWidth = 0;

    constructor(props) {
        super(props);




        // url will always be formatted like this:
        // /reports/top-performers&reportTitle=Top Performers

        // we want to get:
        // the reportType - this will be the slug ("top-performers")
        // the reportTitle - this will be the querystring parameter value

        let vals = queryString.parse(window.location.search);

        // actual name of the report, e.g. "Top Seller Items"
        this.reportTitle = vals.reportTitle;
        //console.log('this.reportTitle', this.reportTitle)

        // 0: all; 1: GM; 2: P&A
        this.values = { orderType: "0", monthYear: "" };

        // if we're drilling down to this report from somewhere else (like the dashboard), then this will be populated.
        // it also means we're going to run the report automatically and that we won't show the report filters.
        this.autoFilterType = vals.autoFilterType;

        // if drilling down to this report, then you can also define a start and end date to the report.
        this.autoFilterStartDate = vals.autoFilterStartDate;
        this.autoFilterEndDate = vals.autoFilterEndDate;

        // create a link to the previous page (whatever that happens to be), so the user has an easy way to navigate back there.
        this.previousPageUrl = vals.previousPageUrl;
        this.previousPageTitle = vals.previousPageTitle;

        // get the URL minus the querystring.
        // we want to get the type of the report from the URL.
        // e.g. if the URL is /reports/top-seller-items, then this.reportType = "top-seller-items"
        const urlPath = window.location.href.replace(window.location.search, '');
        const urlPathFragments = urlPath.split('/');
        this.reportType = urlPathFragments[urlPathFragments.length - 1]


        this.state = {
            suggestedOrders: [],
            //columns: [],
            setMinWidth: false,
            gridCurrent: 0,
            currentResultSettings: [],
        };
    }

    state = {
        reportData: null,
        filterControls: null,
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleItemChange = (e) => {
        //console.log('handleItemChange')
        e.dataItem[e.field] = e.value;
        e.dataItem['updated'] = e.dataItem['updated'] === 0 ? 1 : e.dataItem['updated'];

        const index = e.dataItem['index'];

        this.setState({
            reportData: Object.assign([], this.state.reportData, { [index]: e.dataItem }),
            unsaved: true
        });
    }

    componentDidMount() {
        // if we are drilling down to reports (which is the case if this.autoFilterType is nonempty),
        // then just run the report right away. don't show the report filters to the user. 

        // otherwise we'll expose the report filters to the user.
        if (!isEmpty(this.autoFilterType)) {
            const params = {}
            params.autoFilterType = this.autoFilterType;

            //let builder = new queryStringBuilder();

            if (!isEmpty(this.autoFilterType)) {
                params.autoFilterType = this.autoFilterType;
            }
            if (!isEmpty(this.autoFilterStartDate)) {
                params.startDate = this.autoFilterStartDate;
            }
            if (!isEmpty(this.autoFilterEndDate)) {
                params.endDate = this.autoFilterEndDate;
            }

            // 
            const qs = queryString.parse(window.location.search);
            if (qs.orgID) {
                params.orgID = qs.orgID;
            }
            if (qs.reportGroupID) {
                params.reportGroupID = qs.reportGroupID;
            }
            if (qs.vendorID) {
                params.vendorID = qs.vendorID;
            }

            // grab the orgID, reportGroupID and vendorID

            // all report API endpoints look like this: /api/portal/report/${endpointSlug}
            // or /api/portal/report/slowmovingitems?autoFilterType=${endpointSlug}&
            const endpointSlug = this.reportType.replace(/-/g, '');
            //const apiUrl = `/api/portal/report/${endpointSlug}?${queryString.stringify(params)}`;
            let apiUrl;
            switch (this.props.mode) {
                case "normalReports":
                    apiUrl = "/api/portal/report/";
                    break;

                case "adminReports":
                    // get the roleID of the super admin role
                    const superAdminRoleID = getRoleID("superadmin");
                    if (superAdminRoleID) {

                        // grab just the admin reports
                        apiUrl = "/api/portal/admin/report/";
                    }
                    else {
                        this.props.errorAlert("m0370")
                        return;
                    }
                    break;

                default:
                    break;
            }
            switch (endpointSlug) {
                case "agedinventory":
                case "obsoleteinventory":
                    apiUrl = `${apiUrl}slowmovingitems?autoFilterType=${endpointSlug}&`;
                    break;
                default:
                    apiUrl = `${apiUrl}${endpointSlug}?`;
                    break;
            }
            apiUrl = `${apiUrl}${queryString.stringify(params)}`;
            this.callApi(apiUrl);
        }
        //set default start date to one month ago;
        //console.log(this.context.state.selectedReportStartDate);
        if (!this.context.state.selectedReportStartDate) {
            //console.log(moment().add(-30, 'days').format("YYYYMMDD"))
            this.context.setState({ selectedReportStartDate: moment().add(-30, 'days').toDate() });
        }
    }


    expandChange = e => {

        e.dataItem.expanded = !e.dataItem.expanded;
        this.forceUpdate();
    };


    getFilterValues = (values) => {
        this.values = values;
    }

    parseTitle(reportType) {
        //parse reportType slug into localisation code for rendering, adjust this when adding new reports
        switch (reportType) {
            case "top-seller-items":
                return "m0523";
            case "slow-moving-items":
                return "m0524";
            case "top-performers":
                return "m0525";
            case "top-overstocking":
                return "m0526";
            case "suggested-order-history":
                return "m0527";
            case "aged-inventory":
                return "m0528";
            case "obsolete-inventory":
                return "m0529";
            case "inventory-mix-comparison":
                return "m0530";
            case "inventory-mix-history":
                return "m0531";
            case "part-sales-history":
                return "m0532";
            case "som-usage-stats":
                return "m0533";
            case "som-adoption":
                return "m0534";
            default:
                return ""
        }

    }

    // handles the submission of the search criteria, and RUN THE REPORT
    callApi = (apiUrl) => {
        console.log(apiUrl);
        //https://dv0som000devweb01.azurewebsites.net/api/portal/report/TopSellerItems?startDate=2018-12-02T08:00:00.000Z&orgID=38
        this.props
            .getData(apiUrl)
            .then(response => {
                // grid may not exist yet, but it has the same width as the search-controls, so use it to calculate column widths
                //this.grid = document.querySelector('.k-grid');
                this.grid = document.querySelector('.report-search-panel');
                window.addEventListener('resize', this.handleResize);
                let columns;
                if (this.reportType === "top-seller-items") {
                    columns = columnsTopSellerItems(this.props);
                    this.minGridWidth = 560;
                }
                else if (this.reportType === "slow-moving-items" || this.reportType === "aged-inventory" || this.reportType === "obsolete-inventory") {
                    columns = columnsInventory(this.props);
                    this.minGridWidth = 505;
                }
                else if (this.reportType === "top-performers") {
                    columns = columnsTopPerformers(this.props);
                    this.minGridWidth = 610;
                }
                else if (this.reportType === "top-overstocking") {
                    columns = columnsTopOverstocking(this.props);
                    this.minGridWidth = 345;
                }
                else if (this.reportType === "suggested-order-history") {
                    columns = columnsSuggestedOrderHistory(this.props);
                    this.minGridWidth = 567;
                }
                else if (this.reportType === "inventory-mix-comparison") {
                    columns = columnsInventoryMixComparison(this.props);
                    this.minGridWidth = 1015;
                }
                else if (this.reportType === "inventory-mix-history") {
                    columns = columnsInventoryMixHistory(this.props);
                    this.minGridWidth = 985;
                }
                else if (this.reportType === "part-sales-history") {
                    columns = columnsPartSalesHistory(this.props);
                    this.minGridWidth = 1200;
                }
                else if (this.reportType === "som-usage-stats") {
                    columns = columnsUsageStats(this.props);
                    this.minGridWidth = 1030;
                }
                else if (this.reportType === "som-adoption") {
                    columns = columnsAdoption(this.props);
                    this.minGridWidth = 840;
                }
                columns.map(item => this.minGridWidth += item.minWidnt);

                this.setState({
                    reportData: response.data,

                    //columns: columns,
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: this.grid.offsetWidth < this.minGridWidth
                }/*, console.log(response.data)*/)
                // debugger;
                // this.setState({
                //     reportData: (apiUrl.indexOf("Suggested") >= 0) ?
                //         response.data.map((order, index) =>
                //             Object.assign({
                //                 parts: order.parts.map((part, index) => (
                //                     Object.assign({
                //                         orderQty: Math.floor(Math.random() * 10),
                //                         adjustmentReason: "Out of season",
                //                         suggestedQty: Math.floor(Math.random() * 10)
                //                     }, part))
                //                 )
                //             }, order)
                //         ) : response.data
                // });

            })
            .catch(error => {
                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0371")
                );
            });
    };


    handleResize = () => {
        //console.log("grid.offsetWidth: ", this.grid.offsetWidth);

        if (this.grid) {
            if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
                this.setState({
                    setMinWidth: true
                });
            } else if (this.grid.offsetWidth > this.minGridWidth) {
                this.setState({
                    gridCurrent: this.grid.offsetWidth,
                    setMinWidth: false
                });
            }
        }
    }

    setWidth = (minWidth, percentage) => {
        //console.log("state.gridCurrent: ", this.state.gridCurrent);
        //if (this.grid)
        //    console.log("grid.offsetWidth: ", this.grid.offsetWidth);
        //let columnsLength;
        //if (this.context.state.allowEditSuggestedOrders)
        //    columnsLength = columnsAllowEdit.length;
        //else
        //    columnsLength = columnsNotAllowEdit.length;
        //let width = this.state.setMinWidth ? minWidth :
        //    minWidth + (this.state.gridCurrent - this.minGridWidth) / columnsLength;
        let width = this.state.setMinWidth ? minWidth :
            Math.round(this.state.gridCurrent / 100 * percentage);
        width = width < COLUMN_MIN ? width : width - ADJUST_PADDING;
        //console.log("width: ", width);
        return width;
    }

    getCsvData = () => {
        let csvData = [];

        const { allowEditSuggestedOrders } = this.context.state;

        this.state.reportData.forEach(order => {
            // if allowing user to edit suggested orders, then ....
            //      export order quantity (if defined, otherwise export suggested quantity)
            // else
            //      export suggested quantity only
            let quantity = (allowEditSuggestedOrders ? (isEmpty(order.orderQuantity) ? 0 : order.orderQuantity) : order.suggestedQuantity);
            if (quantity > 0) {
                csvData.push([
                    order.partNumber,
                    quantity
                ]);
            }

        });
        //console.log(csvData)
        return csvData;
    }

    getTabs = () => {

        //const tabLabel = (isEmpty(this.previousPageTitle)) ? 'Go back to reports listing' : `Go back to ${this.previousPageTitle}`;
        //const tabLink = (isEmpty(this.previousPageUrl)) ? '/reports' : this.previousPageUrl;

        //<Tabs activeTab="0">
        //    <Tab label={tabLabel} link={tabLink} />
        //</Tabs>
        let label;
        let link;
        let linkParams;

        switch (this.props.mode) {
            case "normalReports":
                label = this.props.returnLocalizedString("m0379");
                link = '/reports';
                linkParams = "";
                break;

            case "adminReports":
                // get the roleID of the super admin role
                const superAdminRoleID = getRoleID("superadmin");
                if (superAdminRoleID) {

                    // grab just the admin reports
                    label = this.props.returnLocalizedString("m0381");
                    link = '/admin/reports';
                    linkParams = "?roleID=572180F3-3F48-4523-B547-2B134FCB05CF&role=superadmin";
                }
                else {
                    this.props.errorAlert("m0372")
                    return;
                }
                break;
            default:
                break;
        }

        return (

            <Tabs>
                <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                <Tab label={label} link={link} linkParams={linkParams} ></Tab>
                <Tab label={this.props.returnLocalizedString(this.parseTitle(this.reportType))} ></Tab>
            </Tabs>

        );
    }

    rowRender = (row, props) => {
        let newRow = row;
        if (this.reportType === "suggested-order-history") {
            // check if the total items is zero, then hide the expander
            if (props.dataItem.totalItems === 0) {
                newRow.props.children[0] = (<td key={uuidv4()}></td>);
            }
        }
        return newRow;
    }

    render() {
        // get the breadcrumbs
        const tabs = this.getTabs();

        // get the description for this particular report
        const reportTitle = kebabCase(this.reportTitle)
        const reportDescription = config.reportDescriptions[reportTitle]

        // create the mxxx code for label that goes into the header section of the page
        let headerLabel = '';
        //if (isEmpty(this.autoFilterType)) {
        //    headerLabel = 'Reports > ';
        //}
        headerLabel += this.parseTitle(this.reportType);
        //create file export name
        const exportFileName = kebabCase(this.props.returnLocalizedString(headerLabel))

        //const previousPageTitle = (isEmpty(this.previousPageTitle)) ? "Reports" : this.previousPageTitle;
        //const previousPageUrl = (isEmpty(this.previousPageUrl)) ? '/reports' : this.previousPageUrl;
        const previousPageTitle = '';
        const previousPageUrl = '';

        //!DBTRANS! @m0004@ Home !DEVNOTE! Option label
        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0102@ Org Name !DEVNOTE! Column label
        //!DBTRANS! @m0104@ Country !DEVNOTE! Column label
        //!DBTRANS! @m0257@ Part number !DEVNOTE! Input field label
        //!DBTRANS! @m0258@ Description !DEVNOTE! Input field label
        //!DBTRANS! @m0267@ Total !DEVNOTE! Time label
        //!DBTRANS! @m0259@ Vendor !DEVNOTE! Input field label
        //!DBTRANS! @m0290@ Status !DEVNOTE! Column Label
        //!DBTRANS! @m0200@ Dealer Name  !DEVNOTE! Column label
        //!DBTRANS! @m0314@ Suggested Qty !DEVNOTE! Column label
        //!DBTRANS! @m0315@ Order Qty !DEVNOTE! Column label
        //!DBTRANS! @m0316@ Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0317@ Units/Pkg !DEVNOTE! Column label
        //!DBTRANS! @m0318@ Cost !DEVNOTE! Column label
        //!DBTRANS! @m0319@ There is no data to show here. !DEVNOTE! Column label
        //!DBTRANS! @m0320@ Part Description !DEVNOTE! Column label
        //!DBTRANS! @m0321@ Quantity Available !DEVNOTE! Column label
        //!DBTRANS! @m0322@ Total Value !DEVNOTE! Column label
        //!DBTRANS! @m0323@ Quantity Sold !DEVNOTE! Column label
        //!DBTRANS! @m0324@ Last Sold Date !DEVNOTE! Column label
        //!DBTRANS! @m0325@ Last Month Revenue !DEVNOTE! Column label
        //!DBTRANS! @m0326@ Last Month Profit !DEVNOTE! Column label
        //!DBTRANS! @m0327@ Aged Inventory !DEVNOTE! Column label
        //!DBTRANS! @m0328@ Inventory Turnover Rate !DEVNOTE! Column label
        //!DBTRANS! @m0329@ GMROI !DEVNOTE! Column label
        //!DBTRANS! @m0330@ Aged Value !DEVNOTE! Column label
        //!DBTRANS! @m0331@ Order Date !DEVNOTE! Column label
        //!DBTRANS! @m0332@ Vendor Code !DEVNOTE! Column label
        //!DBTRANS! @m0333@ Total Items !DEVNOTE! Column label
        //!DBTRANS! @m0334@ Dealer Number !DEVNOTE! Column label
        //!DBTRANS! @m0335@ Inventory Value !DEVNOTE! Column label
        //!DBTRANS! @m0336@ Aged Percent !DEVNOTE! Column label
        //!DBTRANS! @m0337@ Obsolete Percent !DEVNOTE! Column label
        //!DBTRANS! @m0338@ Obsolete Value !DEVNOTE! Column label
        //!DBTRANS! @m0339@ Slow Moving Percent !DEVNOTE! Column label
        //!DBTRANS! @m0340@ Slow Moving Value !DEVNOTE! Column label
        //!DBTRANS! @m0341@ Average Moving Percent !DEVNOTE! Column label
        //!DBTRANS! @m0342@ Average Moving Value !DEVNOTE! Column label
        //!DBTRANS! @m0343@ Fast Moving Percent !DEVNOTE! Column label
        //!DBTRANS! @m0344@ Fast Moving Value !DEVNOTE! Column label
        //!DBTRANS! @m0345@ Total Qty Sold !DEVNOTE! Column label
        //!DBTRANS! @m0346@ Qty Refunded !DEVNOTE! Column label
        //!DBTRANS! @m0347@ Qty Special Ordered !DEVNOTE! Column label
        //!DBTRANS! @m0348@ Current Qty Available !DEVNOTE! Column label
        //!DBTRANS! @m0349@ Current Qty On Order !DEVNOTE! Column label
        //!DBTRANS! @m0350@ Current Qty In Progress !DEVNOTE! Column label
        //!DBTRANS! @m0351@ Product Group !DEVNOTE! Column label
        //!DBTRANS! @m0352@ Date !DEVNOTE! Column label
        //!DBTRANS! @m0353@ User Name !DEVNOTE! Column label
        //!DBTRANS! @m0354@ Logins !DEVNOTE! Column label
        //!DBTRANS! @m0355@ Order Views !DEVNOTE! Column label
        //!DBTRANS! @m0356@ CSV Order Exports !DEVNOTE! Column label
        //!DBTRANS! @m0357@ XLS Order Exports !DEVNOTE! Column label
        //!DBTRANS! @m0358@ API Order Exports !DEVNOTE! Column label
        //!DBTRANS! @m0359@ Never Orders !DEVNOTE! Column label
        //!DBTRANS! @m0360@ Order Quantity Edits !DEVNOTE! Column label
        //!DBTRANS! @m0361@ Stocking Edits !DEVNOTE! Column label
        //!DBTRANS! @m0362@ Report Views !DEVNOTE! Column label
        //!DBTRANS! @m0363@ Org ID !DEVNOTE! Column label
        //!DBTRANS! @m0364@ Vendor Name !DEVNOTE! Column label
        //!DBTRANS! @m0365@ Submitted on From !DEVNOTE! Column label
        //!DBTRANS! @m0366@ Submitted on To !DEVNOTE! Column label
        //!DBTRANS! @m0367@ Ordered from Suggested Parts Qty % !DEVNOTE! Column label
        //!DBTRANS! @m0368@ Ordered from Suggested Parts Value % !DEVNOTE! Column label
        //!DBTRANS! @m0369@ SOM Suggested Portion of PO Total Value % !DEVNOTE! Column label
        //!DBTRANS! @m0370@ Unable to retrieve list of admin report url. !DEVNOTE! Action status
        //!DBTRANS! @m0371@ Unable to retrieve report data. Please try again. !DEVNOTE! Action status
        //!DBTRANS! @m0372@ Unable to retrieve list of admin reports. !DEVNOTE! Action status
        //!DBTRANS! @m0373@ Total Sales !DEVNOTE! Column label
        //!DBTRANS! @m0374@ Total Sales Hit !DEVNOTE! Column label
        //!DBTRANS! @m0375@ .xls Export !DEVNOTE! Column label
        //!DBTRANS! @m0523@ Top Seller Items !DEVNOTE! Report Title
        //!DBTRANS! @m0524@ Slow Moving Items !DEVNOTE! Report Title
        //!DBTRANS! @m0525@ Top Performers !DEVNOTE! Report Title
        //!DBTRANS! @m0526@ Top Overstocking !DEVNOTE! Report Title
        //!DBTRANS! @m0527@ Suggested Order History !DEVNOTE! Report Title
        //!DBTRANS! @m0528@ Aged Inventory !DEVNOTE! Report Title
        //!DBTRANS! @m0529@ Obsolete Inventory !DEVNOTE! Report Title
        //!DBTRANS! @m0530@ Inventory Mix Comparison !DEVNOTE! Report Title
        //!DBTRANS! @m0531@ Inventory Mix History !DEVNOTE! Report Title
        //!DBTRANS! @m0532@ Part Sales History !DEVNOTE! Report Title
        //!DBTRANS! @m0533@ SOM Usage Stats !DEVNOTE! Report Title
        //!DBTRANS! @m0534@ SOM Adoption !DEVNOTE! Report Title
        //!DBTRANS! @m0379@ Reports !DEVNOTE! Sidebar Title 
        //!DBTRANS! @m0381@ Admin reports !DEVNOTE! Title

        return (
            <AppContext.Consumer>
                {context => (
                    <div className="reports">
                        <Header title={this.props.returnLocalizedString(headerLabel)} tabs={tabs} toolTipText={this.props.returnLocalizedString(reportDescription)} previousPageTitle={previousPageTitle} previousPageUrl={previousPageUrl} />
                        <section className="page-content grid-row pad-it">
                            {
                                // If we're drilling down to this report, then DON'T show the report filters
                                isEmpty(this.autoFilterType) && (
                                    <ReportsDataFilters
                                        reportType={this.reportType}
                                        reportTitle={this.reportTitle}
                                        callApi={this.callApi}
                                        getFilterValues={this.getFilterValues}
                                        mode={this.props.mode}
                                    >
                                        {this.state.filterControls}

                                    </ReportsDataFilters>
                                )}

                            {this.reportType === "top-seller-items" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="partNumber"
                                        title={this.props.returnLocalizedString("m0257")}
                                        width={this.setWidth(110, 15)}
                                    />
                                    <Column
                                        field="vendorCode"
                                        title={this.props.returnLocalizedString("m0259")}
                                        width={this.setWidth(70, 12)}
                                    />
                                    <Column
                                        field="partDescription"
                                        title={this.props.returnLocalizedString("m0258")}
                                        width={this.setWidth(100, 35)}
                                    />
                                    <Column
                                        field="qtyInStock"
                                        title={this.props.returnLocalizedString("m0321")}
                                        width={this.setWidth(80, 12)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="totalValue"
                                        title={this.props.returnLocalizedString("m0322")}
                                        width={this.setWidth(95, 12)}
                                        className='numeric'
                                        headerClassName='numeric'
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="qtySold"
                                        title={this.props.returnLocalizedString("m0323")}
                                        width={this.setWidth(115, 12)}
                                        className="numeric"
                                        headerClassName="numeric"
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {(this.reportType === "slow-moving-items" || this.reportType === "aged-inventory" || this.reportType === "obsolete-inventory") && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="partNumber"
                                        title={this.props.returnLocalizedString("m0257")}
                                        width={this.setWidth(110, 12)}
                                    />
                                    <Column
                                        field="vendorCode"
                                        title={this.props.returnLocalizedString("m0259")}
                                        width={this.setWidth(70, 12)}
                                    />
                                    <Column
                                        field="partDescription"
                                        title={this.props.returnLocalizedString("m0258")}
                                        width={this.setWidth(100, 30)}
                                    />
                                    <Column
                                        field="qtyInStock"
                                        title={this.props.returnLocalizedString("m0321")}
                                        width={this.setWidth(80, 12)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="totalValue"
                                        title={this.props.returnLocalizedString("m0322")}
                                        width={this.setWidth(95, 12)}
                                        className='numeric'
                                        headerClassName='numeric'
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="lastSoldDate"
                                        title={this.props.returnLocalizedString("m0324")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(80, 10)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="status"
                                        title={this.props.returnLocalizedString("m0290")}
                                        width={this.setWidth(70, 10)}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {this.reportType === "top-performers" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName, "xlsx", "0", this.values.monthYear)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="dealerNumber"
                                        title={this.props.returnLocalizedString("m0334")}
                                        width={this.setWidth(75, 12)}
                                    />
                                    <Column
                                        field="dealerName"
                                        title={this.props.returnLocalizedString("m0200")}
                                        width={this.setWidth(110, 20)}
                                    />
                                    <Column
                                        field="lastMonthRevenue"
                                        title={this.props.returnLocalizedString("m0325")}
                                        width={this.setWidth(95, 14)}
                                        className="numeric"
                                        headerClassName="numeric"
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="lastMonthProfit"
                                        title={this.props.returnLocalizedString("m0326")}
                                        width={this.setWidth(95, 14)}
                                        className="numeric"
                                        headerClassName="numeric"
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="agedInventory9month"
                                        title={this.props.returnLocalizedString("m0327")}
                                        width={this.setWidth(80, 14)}
                                        className="numeric"
                                        headerClassName="numeric"
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="inventoryTurnoverRate"
                                        title={this.props.returnLocalizedString("m0328")}
                                        //cell={props => (
                                        //    <PercentCell {...props} />
                                        //)}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(85, 12)}
                                    />
                                    <Column
                                        field="gmroi"
                                        title={this.props.returnLocalizedString("m0329")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        //cell={props => (
                                        //    <PercentCell {...props} />
                                        //)}
                                        width={this.setWidth(70, 12)}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {this.reportType === "top-overstocking" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="dealerNumber"
                                        title={this.props.returnLocalizedString("m0334")}
                                        width={this.setWidth(125, 20)}
                                    />
                                    <Column
                                        field="dealerName"
                                        title={this.props.returnLocalizedString("m0200")}
                                        width={this.setWidth(110, 50)}
                                    />
                                    <Column
                                        field="agedValue"
                                        title={this.props.returnLocalizedString("m0330")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(110, 28)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />

                                </GridContainer>

                            )}
                            {this.reportType === "suggested-order-history" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName, "xlsx", this.values.orderType)}

                                    detail={SuggestedHistoryDetailedComponentLocalized}
                                    rowRender={this.rowRender}
                                    onExpandChange={this.expandChange}
                                >
                                    <Column
                                        field="orderDate"
                                        title={this.props.returnLocalizedString("m0331")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(75, 12)}
                                        className='date'
                                        headerClassName='date'
                                    />

                                    <Column
                                        field="vendorCode"
                                        title={this.props.returnLocalizedString("m0332")}
                                        width={this.setWidth(110, 40)}
                                    />

                                    <Column
                                        field="totalItems"
                                        title="Total Items"
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(110, 12)}
                                    />

                                    <Column
                                        field="totalValue"
                                        title={this.props.returnLocalizedString("m0322")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(90, 12)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        filterable={false}
                                        sortable={false}
                                        reorderable={false}
                                        width={this.setWidth(150, 14)}
                                        cell={(props) => (
                                            <ExcelExportButtonCell text={this.props.returnLocalizedString("m0375")} {...props} />
                                        )}
                                        editable={false}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {this.reportType === "inventory-mix-comparison" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="dealerNumber"
                                        title={this.props.returnLocalizedString("m0334")}
                                        width={this.setWidth(85, 8)}
                                    />
                                    <Column
                                        field="dealerName"
                                        title={this.props.returnLocalizedString("m0200")}
                                        width={this.setWidth(85, 12)}
                                    />
                                    <Column
                                        field="inventoryValue"
                                        title={this.props.returnLocalizedString("m0335")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(110, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="agedPercent"
                                        title={this.props.returnLocalizedString("m0336")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 6)}
                                    />
                                    <Column
                                        field="agedValue"
                                        title={this.props.returnLocalizedString("m0330")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="obsoletePercent"
                                        title={this.props.returnLocalizedString("m0337")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(80, 6)}
                                    />
                                    <Column
                                        field="obsoleteValue"
                                        title={this.props.returnLocalizedString("m0338")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(80, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="slowMovingPercent"
                                        title={this.props.returnLocalizedString("m0339")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 6)}
                                    />
                                    <Column
                                        field="slowMovingValue"
                                        title={this.props.returnLocalizedString("m0340")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="averageMovingPercent"
                                        title={this.props.returnLocalizedString("m0341")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(75, 6)}
                                    />
                                    <Column
                                        field="averageMovingValue"
                                        title={this.props.returnLocalizedString("m0342")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(80, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="fastMovingPercent"
                                        title={this.props.returnLocalizedString("m0343")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 6)}
                                    />
                                    <Column
                                        field="fastMovingValue"
                                        title={this.props.returnLocalizedString("m0344")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />

                                </GridContainer>

                            )}
                            {this.reportType === "inventory-mix-history" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="date"
                                        title={this.props.returnLocalizedString("m0352")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(80, 10)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="inventoryValue"
                                        title={this.props.returnLocalizedString("m0335")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(95, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="agedPercent"
                                        title={this.props.returnLocalizedString("m0336")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                    />
                                    <Column
                                        field="agedValue"
                                        title={this.props.returnLocalizedString("m0330")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(95, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="obsoletePercent"
                                        title={this.props.returnLocalizedString("m0337")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(75, 8)}
                                    />
                                    <Column
                                        field="obsoleteValue"
                                        title={this.props.returnLocalizedString("m0338")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(95, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="slowMovingPercent"
                                        title={this.props.returnLocalizedString("m0339")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                    />
                                    <Column
                                        field="slowMovingValue"
                                        title={this.props.returnLocalizedString("m0340")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(95, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="averageMovingPercent"
                                        title={this.props.returnLocalizedString("m0341")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                    />
                                    <Column
                                        field="averageMovingValue"
                                        title={this.props.returnLocalizedString("m0342")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(85, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="fastMovingPercent"
                                        title={this.props.returnLocalizedString("m0343")}
                                        cell={props => (
                                            <PercentCell {...props} />
                                        )}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(70, 8)}
                                    />
                                    <Column
                                        field="fastMovingValue"
                                        title={this.props.returnLocalizedString("m0344")}
                                        className="numeric"
                                        headerClassName="numeric"
                                        width={this.setWidth(85, 8)}
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />

                                </GridContainer>

                            )}
                            {this.reportType === "part-sales-history" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="partNumber"
                                        title={this.props.returnLocalizedString("m0257")}
                                        width={this.setWidth(85, 8)}
                                    />
                                    <Column
                                        field="vendorCode"
                                        title={this.props.returnLocalizedString("m0259")}
                                        width={this.setWidth(285, 7)}
                                    />
                                    <Column
                                        field="partDescription"
                                        title={this.props.returnLocalizedString("m0258")}
                                        width={this.setWidth(90, 16)}
                                    />
                                    <Column
                                        field="totalSales"
                                        title={this.props.returnLocalizedString("m0373")}
                                        width={this.setWidth(90, 8)}
                                        className='numeric'
                                        headerClassName='numeric'
                                        cell={props => (
                                            <CurrencyCell {...props} />
                                        )}
                                    />
                                    <Column
                                        field="totalSalesHit"
                                        title={this.props.returnLocalizedString("m0374")}
                                        width={this.setWidth(80, 7)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="totalQtySold"
                                        title={this.props.returnLocalizedString("m0345")}
                                        width={this.setWidth(90, 8)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="qtySpecialOrdered"
                                        title={this.props.returnLocalizedString("m0347")}
                                        width={this.setWidth(80, 7)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="maxSoldDate"
                                        title={this.props.returnLocalizedString("m0324")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(80, 7)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="currentQtyAvailable"
                                        title={this.props.returnLocalizedString("m0348")}
                                        width={this.setWidth(80, 7)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="currentQtyOnOrder"
                                        title={this.props.returnLocalizedString("m0349")}
                                        width={this.setWidth(80, 7)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="currentQtySalesInProgress"
                                        title={this.props.returnLocalizedString("m0350")}
                                        width={this.setWidth(80, 7)}
                                        className='numeric current'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="productGroup"
                                        title={this.props.returnLocalizedString("m0351")}
                                        width={this.setWidth(80, 9)}
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {this.reportType === "som-usage-stats" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="date"
                                        title={this.props.returnLocalizedString("m0352")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(85, 10)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="country"
                                        title={this.props.returnLocalizedString("m0104")}
                                        width={this.setWidth(75, 10)}
                                    />
                                    <Column
                                        field="orgName"
                                        title={this.props.returnLocalizedString("m0102")}
                                        width={this.setWidth(120, 12)}
                                    />
                                    <Column
                                        field="userName"
                                        title={this.props.returnLocalizedString("m0353")}
                                        width={this.setWidth(100, 12)}
                                    />
                                    <Column
                                        field="logins"
                                        title={this.props.returnLocalizedString("m0354")}
                                        width={this.setWidth(70, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="orderViews"
                                        title={this.props.returnLocalizedString("m0355")}
                                        width={this.setWidth(70, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="csvOrderExports"
                                        title={this.props.returnLocalizedString("m0356")}
                                        width={this.setWidth(70, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="xlsOrderExports"
                                        title={this.props.returnLocalizedString("m0357")}
                                        width={this.setWidth(80, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="apiOrderExports"
                                        title={this.props.returnLocalizedString("m0358")}
                                        width={this.setWidth(80, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="neverOrders"
                                        title={this.props.returnLocalizedString("m0359")}
                                        width={this.setWidth(70, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="orderQuantityEdits"
                                        title={this.props.returnLocalizedString("m0360")}
                                        width={this.setWidth(75, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="stockingEdits"
                                        title={this.props.returnLocalizedString("m0361")}
                                        width={this.setWidth(75, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="reportViews"
                                        title={this.props.returnLocalizedString("m0362")}
                                        width={this.setWidth(60, 6)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />
                                </GridContainer>
                            )}
                            {this.reportType === "som-adoption" && this.state.reportData && (
                                <GridContainer
                                    data={this.state.reportData}
                                    sortColumn=""
                                    excelFilename={getExportFileName(exportFileName)}
                                    pageable={true}
                                    pageSizes={[25, 50, 100, 150]}
                                    pageSize={50}
                                >
                                    <Column
                                        field="orgName"
                                        title={this.props.returnLocalizedString("m0102")}
                                        width={this.setWidth(110, 20)}
                                    />
                                    <Column
                                        field="orgID"
                                        title={this.props.returnLocalizedString("m0363")}
                                        width={this.setWidth(60, 8)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="vendorName"
                                        title={this.props.returnLocalizedString("m0364")}
                                        width={this.setWidth(120, 20)}
                                    />
                                    <Column
                                        field="submittedOnFrom"
                                        title={this.props.returnLocalizedString("m0365")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(110, 10)}
                                        className='date'
                                        headerClassName='date'
                                    />
                                    <Column
                                        field="submittedOnTo"
                                        title={this.props.returnLocalizedString("m0366")}
                                        cell={props => (
                                            <DateCell {...props} />
                                        )}
                                        width={this.setWidth(110, 10)}
                                        className='date'
                                        headerClassName='date'
                                    />

                                    <Column
                                        field="orderedFromSuggestedPartsQtyPct"
                                        title={this.props.returnLocalizedString("m0367")}
                                        width={this.setWidth(110, 10)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="orderedFromSuggestedPartsValuePct"
                                        title={this.props.returnLocalizedString("m0368")}
                                        width={this.setWidth(110, 10)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        field="sOMSuggestedPortionOfPOTotalValuePct"
                                        title={this.props.returnLocalizedString("m0369")}
                                        width={this.setWidth(110, 10)}
                                        className='numeric'
                                        headerClassName='numeric'
                                    />
                                    <Column
                                        excludeFromExport
                                        filterable={false}
                                        resizable={false}
                                        sortable={false}
                                        reorderable={false}
                                        editable={false}
                                        cell={(props) => (
                                            <BlankCell {...props} />
                                        )}
                                    />

                                </GridContainer>

                            )}
                        </section>
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}
ReportsDataPage.contextType = AppContext;
export default compose(isPage)(ReportsDataPage);





// WEBPACK FOOTER //
// ./src/containers/ReportsDataPage.js